import React from 'react';
import IntroSection from './IntroSection';

const LandingLayout: React.FC = () => {
	return (
		<>
			<IntroSection />
		</>
	);
};

export default LandingLayout;
